import * as React from "react";
import type { SpendFamilySummary } from "@/types/spend";

interface Props {
  families: SpendFamilySummary[];
  selected: string;
  onSelect: (id: string) => void;
}

export const FamilyTabs = ({ families, selected, onSelect }: Props) => {
  const tabs = [{ relation_id: "all", name: "All families", procurement_status: "", currency_code: null }, ...families];
  const listRef = React.useRef<HTMLDivElement>(null);
  const moveFocus = (event: React.KeyboardEvent, index: number) => {
    if (event.key !== "ArrowLeft" && event.key !== "ArrowRight") return;
    event.preventDefault();
    const next = event.key === "ArrowRight" ? (index + 1) % tabs.length : (index - 1 + tabs.length) % tabs.length;
    listRef.current?.querySelectorAll<HTMLButtonElement>('[role="tab"]')[next]?.focus();
  };

  return (
    <div
      ref={listRef}
      className="flex gap-1 overflow-x-auto border-b border-[#ddd5cb]"
      role="tablist"
      aria-label="Contract Families"
    >
      {tabs.map((family, index) => (
        <button
          key={family.relation_id}
          type="button"
          role="tab"
          aria-selected={selected === family.relation_id}
          tabIndex={selected === family.relation_id ? 0 : -1}
          onClick={() => onSelect(family.relation_id)}
          onKeyDown={event => moveFocus(event, index)}
          className={`whitespace-nowrap border-b-2 px-4 py-3 text-sm font-semibold ${selected === family.relation_id ? "border-desert-sand-700 text-[#111b35]" : "border-transparent text-gray-500"}`}
        >
          {family.name}
          {family.procurement_status ? (
            <span className="ml-2 text-xs capitalize text-gray-400">
              {family.procurement_status}
              {family.currency_code ? ` · ${family.currency_code}` : ""}
            </span>
          ) : null}
        </button>
      ))}
    </div>
  );
};
